export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Empresa de desarrollos digitales',
  headline: 'Llevamos tus ideas a la realidad ',
  description:
    'Nos encargamos de transformar ideas de negocio en proyectos reales. Nuestro equipo de desarrolladores lo ayudaran a diseñar, desarrollar y montar su aplicacion digital para tener su negocio en la web.',
  buttonLabel: 'Comenzar ahora',
  imgStart: '',
  img: require('../../images/svg-1.svg'),
  alt: 'Credit Card',
  start: ''
};

export const homeObjTwo = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Para empezar... ',
  headline: 'Con tu idea clara y lista para comunicarla , te pones en contacto con nosotros via email o Whatsapp para obtener la cotizacion de tu proyecto.',
  description:
    "Una vez que haya solicitado una estimacion, nuestro equipo de especialistas se comunicará con usted y le dara una cotizacion de su idea junto al tiempo de desarrollo estimado del proyecto.",
  buttonLabel: 'Ver mas...',
  imgStart: '',
  img: require('../../images/svg-2.svg'),
  alt: 'Vault',
  start: ''
};

export const homeObjThree = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Nuestros clientes...',
  headline:
    'GroundWire brinda servicios a mas de 100 empresas y emprendedores con sus desarrollos digitales.',
  description:
    "Nos encargamos de proveer servicio de desarrollo, soporte y mantenimiento profesional para nuestros clientes mas exigentes.",
  buttonLabel: 'Cotizar ahora...',
  imgStart: 'start',
  img: require('../../images/ourClients.png'),
  alt: 'Vault',
  start: 'true'
};

export const homeObjFour = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Seguridad y Confidencialidad',
  headline: 'Con GroundWire tus datos están protegidos.',
  description:
    'Nos tomamos muy en serio la seguridad, por lo que todos los desarrollos de aplicaciones digitales cumplen con las normas de proteccion de datos y propiedad intelectual vigentes.',
  buttonLabel: 'Ver mas...',
  imgStart: 'start',
  img: require('../../images/svg-3.svg'),
  alt: 'Vault',
  start: 'true'
};
